module.exports = __webpack_public_path__ + "static/DIFD-logo-ca1afe75e476de844f0919834c36de58.png";